import { useState } from "react";
import Input from "../../components/Input";
import Button from "../../components/Button";
import * as C from "./styles";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const Signin = () => {
  const { signin } = useAuth();
  const navigate = useNavigate();
  const LOGO_URL = "img/RD_EMPRESAS_BCO_GRANDE.png";

  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !senha) {
      setError("Preencha todos os campos");
      return;
    }

    const res = await signin(email, senha);

    if (res) {
      setError(res);
      return;
    }

    navigate("/home");
  };

  const handleSenhaChange = (e) => {
    if (e?.target?.value !== undefined) {
      setSenha(e.target.value);
      setError("");
    }
  };

  return (
    <C.Container>
      <img
        src={LOGO_URL}
        alt="Logo RD Empresas"
        width={300}
        style={{ marginBottom: "20px" }}
      />

      <C.Label>DASHBOARDS</C.Label>
      <C.Content as="form" onSubmit={handleLogin}>
        <Input
          type="email"
          placeholder="digite seu email"
          value={email}
          onChange={(e) => [setEmail(e.target.value), setError("")]}
        />
        <Input
          type="password"
          placeholder="digite sua senha"
          value={senha}
          onChange={handleSenhaChange}
        />
        <C.labelError>{error}</C.labelError>
        <Button Text="Entrar" Type="submit" />
      </C.Content>
    </C.Container>
  );
};

export default Signin;
